{
  "fr": {
    "issue_category": {
      "labels": {
        "backup_category": "Catégorie de remplacement",
        "category_name": "Nom de la catégorie",
        "delete_category": "Supprimer la catégorie \"{name}\" ?",
        "delete_category_disclaimer": "Tous les éléments de SAV avec cette catégorie seront réassignés à la catégorie que vous sélectionnez ci-dessous.",
        "integration_warning": "Une intégration avec le module Après-vente de votre plateforme est active. Si vous souhaitez créer ou modifier des catégories, veuillez nous contacter.",
        "new_category": "Catégorie"
      }
    }
  }
}